export const ADDITION = "addition";
export const SUBTRACTION = "subtraction";
export const DIVISION = "division";
export const MULTIPLICATION = "multiplication";
